import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { t } from '../../../../modules/infra/i18n';
import OrderInfoItemSingle from '../containers/OrderInfoItemSingle';
import { UNASSIGNED_BARBER } from '../../constants';
import * as shapes from '../../shapes';


const OrderInfoItem = ({
  barber,
  items,
  activeBarberId,
  setActiveBarber,
  removeBarber,
  canRemoveBarber,
}) => {
  const avatarSrc = get(barber, 'photos[0].thumbnail');
  const barberName = isEmpty(barber)
    ? t('register:sale.order_info_item.unassigned_sale')
    : `${get(barber, 'firstName')} ${get(barber, 'lastName')}`;
  const barberId = get(barber, 'id', UNASSIGNED_BARBER);

  return (
    <div className={classnames('c-order-item', { 'is-active': barberId === activeBarberId })}>
      <div className="o-flexbox o-flexbox--content-align-center">
        <button
          className="c-btn c-btn--blank c-btn--small u-ph0 u-mv- u-text-left u-1/1 u-flex-1"
          type="button"
          onClick={setActiveBarber(barberId)}
        >
          <span className="o-flexbox o-flexbox--content-align-center">
            <img
              className="c-avatar c-avatar--small u-mr-"
              src={avatarSrc}
              alt=""
              display-if={avatarSrc}
            />
            <span className="u-flex-1 u-co-primary u-type--semibold">
              {barberName}
            </span>
          </span>
        </button>
        <button
          display-if={canRemoveBarber}
          className="c-btn c-btn--blank u-ph0 u--mr- u-font-color-grey"
          type="button"
          onClick={removeBarber(barberId)}
        >&times;</button>
      </div>
      { items.map(id => <OrderInfoItemSingle barberId={barberId} key={id} id={id} />) }
    </div>
  );
};

OrderInfoItem.propTypes = {
  barber: PropTypes.shape({
    photos: PropTypes.array,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeBarberId: shapes.string,
  setActiveBarber: shapes.handler.isRequired,
  removeBarber: shapes.handler.isRequired,
  canRemoveBarber: shapes.flag.isRequired,
};

OrderInfoItem.defaultProps = {
  barber: null,
  activeBarberId: null,
};

export default OrderInfoItem;
